(ns common.widgets.truncated
  (:require ["react-use/lib/useDebounce$default" :as useDebounce]
            ["react-use/lib/useMeasure$default" :as useMeasure]
            [uix.core :as uix :refer [defhook]]))

(defn overflowing? [dom-el]
  (or (> (.-scrollHeight dom-el) (.-clientHeight dom-el))
      (> (.-scrollWidth dom-el) (.-clientWidth dom-el))))

(defn truncate-middle
  "Truncates a text by replacing the middle part with `separator` or `...`,
   when the length of `text` is longer than `max-length`."
  ([text max-length]
   (truncate-middle text max-length "..."))
  ([text max-length separator]
   (if (> (count text) max-length)
     (let [chars (- max-length (count separator))
           front-chars (Math/ceil (/ chars 2))
           back-chars (Math/floor (/ chars 2))]
       (str (subs text 0 front-chars)
            separator
            (subs text (- (count text) back-chars))))
     text)))

;; Prefer this with UIx code - deprecate the component versions?
;; The component versions currently enforce using specific
;; elements and styles, which might not fit all cases.
;; This hooks provides simple access to information if a
;; text element is overflowing which can then be trivially
;; used to enable for example Tooltip.
;; Check manage.ad-variant-preview.view.
(defhook use-overflowing
  "Returns `[overflowing overflow-el-ref]`

  Place the returned ref into element you want to check for overflow,
  and the first value is updated according to overflowing status."
  []
  (let [[measure-ref bounds] (useMeasure)
        local-ref (uix/use-ref)
        [overflowing set-overflowing] (uix/use-state nil)
        ;; Called on element mount/unmount.
        ;; Measure-ref is used to trigger overflow check on dimensions change.
        ;; Local ref is used to access the el directly to check overflowing status.
        ref-fn (uix/use-callback (fn [el]
                                   (measure-ref el)
                                   (reset! local-ref el))
                                 [measure-ref])]
    ;; Debounce the reaction to dimensions changes
    (useDebounce (fn []
                   (set-overflowing (overflowing? @local-ref)))
                 100
                 #js [(.-width bounds) (.-height bounds)])
    [overflowing ref-fn]))
